const BASE_URL = 'ai-service/api/projects'

const projectsRequests = {
  getProjectsRequest: ({
    pageNumber = 1,
    pageSize = 25,
    order = 'asc',
    orderBy = 'Name',
    filters = { Name: '', Description: '', Type: null },
  }) => ({
    url: BASE_URL,
    method: 'get',
    params: {
      pageNumber,
      pageSize,
      column: orderBy,
      order,
      Name: filters.Name,
      Description: filters.Description,
      Type: filters.Type,
    },
  }),
  addProjectRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  updateProjectRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  deleteProjectRequest: ({ projectId }) => ({
    url: `${BASE_URL}/${projectId}`,
    method: 'delete',
  }),
  getProjectRequest: ({ projectId }) => ({
    url: `${BASE_URL}/${projectId}`,
    method: 'get',
  }),
}

export default projectsRequests
